export const marketingLink = "https://www.getbankshot.com/";
